module.exports = __webpack_public_path__ + "static/media/yoga.d4e13e89.svg";